export enum PendingRequestActionType {
  ON_ACCEPT_PENDING_REQUEST,
  ON_REJECT_PENDING_REQUEST,
  SELECT_PENDING_REQUEST,
  RESET_PENDING_REQUEST,
  SET_PENDING_REQUESTS,
  SET_PENDING_REQUESTS_FILTER,
  PENDING_REQUEST_FAILURE,
  DELETE_PENDING_REQUEST,
  START_LOADING,
  STOP_LOADING,
}

export interface IPendingRequestAction<T> {
  type: keyof typeof PendingRequestActionType;
  payload?: T;
}

export const onAcceptPendingRequest = (
  option: boolean
): IPendingRequestAction<any> => {
  return {
    type: "ON_ACCEPT_PENDING_REQUEST",
    payload: option,
  };
};

export const onRejectPendingRequest = (
  option: boolean
): IPendingRequestAction<any> => {
  return {
    type: "ON_REJECT_PENDING_REQUEST",
    payload: option,
  };
};

export const selectPendingRequest = (
  pendingRequest: any
): IPendingRequestAction<any> => {
  return {
    type: "SELECT_PENDING_REQUEST",
    payload: pendingRequest,
  };
};

export const addPendingRequests = (
  listPendingRequests: any[]
): IPendingRequestAction<any> => {
  return {
    type: "SET_PENDING_REQUESTS",
    payload: listPendingRequests,
  };
};

export const addPendingRequestsFilter = (
  listPendingRequestsFilter: any[]
): IPendingRequestAction<any> => {
  return {
    type: "SET_PENDING_REQUESTS_FILTER",
    payload: listPendingRequestsFilter,
  };
};

export const resetPendingRequest = (): IPendingRequestAction<any> => {
  return {
    type: "RESET_PENDING_REQUEST",
  };
};

export const pendingRequestFailure = (
  error: any
): IPendingRequestAction<any> => {
  return {
    type: "PENDING_REQUEST_FAILURE",
    payload: error,
  };
};

export const deletePendingRequest = (
  pendingRequestId: string
): IPendingRequestAction<any> => {
  return {
    type: "DELETE_PENDING_REQUEST",
    payload: pendingRequestId,
  };
};

export const startLoading = (): IPendingRequestAction<any> => {
  return {
    type: "START_LOADING",
  };
};

export const stopLoading = (): IPendingRequestAction<any> => {
  return {
    type: "STOP_LOADING",
  };
};
